import type { FluxErrorEntityErrorCodes } from '../types.js';

export const MfaErrorCodes = {
  MfaDisableInvalidMfaCode: {
    code: 'mfa/disable-invalid-mfa-code',
    explanation: 'O código MFA fornecido para desativar a autenticação multifator é inválido.',
    localizations: {},
    message: 'Código MFA inválido.',
  },
  MfaDisableInvalidSession: {
    code: 'mfa/disable-invalid-session',
    explanation: 'A sessão MFA para desativar a autenticação multifator é inválida.',
    localizations: {},
    message: 'Sessão MFA inválida.',
  },
  MfaEnableInvalidMfaCode: {
    code: 'mfa/enable-invalid-mfa-code',
    explanation: 'O código MFA fornecido para ativar a autenticação multifator é inválido.',
    localizations: {},
    message: 'Código MFA inválido.',
  },
  MfaEnableInvalidSession: {
    code: 'mfa/enable-invalid-session',
    explanation: 'A sessão MFA para ativar a autenticação multifator é inválida.',
    localizations: {},
    message: 'Sessão MFA inválida.',
  },
  MfaInvalidMfaCode: {
    code: 'mfa/invalid-code',
    explanation: 'O código MFA fornecido é inválido.',
    localizations: {},
    message: 'Código inválido.',
  },
  MfaInvalidToken: {
    code: 'mfa/invalid-token',
    explanation: 'O token MFA fornecido é inválido.',
    localizations: {},
    message: 'Token inválido.',
  },
  MfaNotEnabled: {
    code: 'mfa/not-enabled',
    explanation: 'A autenticação multifator não está habilitada para este usuário.',
    localizations: {},
    message: 'MFA não está habilitado.',
  },
  MfaNotFound: {
    code: 'mfa/not-found',
    explanation: 'A configuração de autenticação multifator para este usuário não foi encontrada.',
    localizations: {},
    message: 'Autenticação multifator não encontrada.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'mfa'>;

export const PasswordResetErrorCodes = {
  PasswordResetNotFound: {
    code: 'password-reset/not-found',
    explanation:
      'A solicitação de redefinição de senha que você está tentando acessar não foi encontrada.',
    localizations: {},
    message: 'Solicitação de redefinição de senha não encontrada.',
  },
  PasswordResetTokenAlreadyUsed: {
    code: 'password-reset/token-already-used',
    explanation: 'O token de redefinição de senha que você está tentando usar já foi utilizado.',
    localizations: {},
    message: 'O token de redefinição de senha já foi utilizado.',
  },
  PasswordResetTokenNotFound: {
    code: 'password-reset/token-not-found',
    explanation: 'O token de redefinição de senha que você está tentando usar não foi encontrado.',
    localizations: {},
    message: 'Token de redefinição de senha não encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'password-reset'>;

export const RecoveryCodesErrorCodes = {
  RecoveryCodeAlreadyUsed: {
    code: 'recovery-code/already-used',
    explanation: 'O código de recuperação que você está tentando usar já foi utilizado.',
    localizations: {},
    message: 'Código de recuperação já utilizado.',
  },
  RecoveryCodeInvalidRecoveryCode: {
    code: 'recovery-code/invalid',
    explanation: 'O código de recuperação fornecido é inválido.',
    localizations: {},
    message: 'Código de recuperação inválido.',
  },
  RecoveryCodeInvalidToken: {
    code: 'recovery-code/invalid-token',
    explanation: 'O token de recuperação fornecido é inválido.',
    localizations: {},
    message: 'Token de recuperação inválido.',
  },
  RecoveryCodeUserNotFound: {
    code: 'recovery-code/user-not-found',
    explanation: 'O usuário associado a este código de recuperação não foi encontrado.',
    localizations: {},
    message: 'Usuário não encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'recovery-code'>;

export const SignInErrorCodes = {
  SignInBradescoAccountNotFound: {
    code: 'sign-in/bradesco-account-not-found',
    explanation: 'A conta Bradesco que você está tentando usar para entrar não foi encontrada.',
    ignored: true,
    localizations: {},
    message: 'Conta Bradesco não encontrada.',
  },
  SignInInvalidBradescoToken: {
    code: 'sign-in/invalid-bradesco-token',
    explanation: 'O token de autenticação do Bradesco fornecido é inválido.',
    ignored: true,
    localizations: {},
    message: 'Autenticação via Bradesco inválida. Verifique suas informações e tente novamente.',
  },
  SignInInvalidGoogleToken: {
    code: 'sign-in/invalid-google-token',
    explanation: 'O token de autenticação do Google fornecido é inválido. Tente entrar novamente.',
    localizations: {},
    message: 'Autenticação via Google inválida.',
  },
  SignInMethodNotImplemented: {
    code: 'sign-in/method-not-implemented',
    explanation: 'O método de login que você está tentando usar ainda não foi implementado.',
    localizations: {},
    message: 'Este método de login ainda não foi implementado.',
  },
  SignInNotFound: {
    code: 'sign-in/not-found',
    explanation: 'O usuário que você está tentando usar para entrar não foi encontrado.',
    localizations: {},
    message: 'Usuário não encontrado.',
  },
  SignInUserNotFound: {
    code: 'sign-in/user-not-found',
    explanation: 'O usuário que você está tentando usar para entrar não foi encontrado.',
    localizations: {},
    message: 'Usuário não encontrado.',
  },
  SignInUserUnauthorized: {
    code: 'sign-in/user-unauthorized',
    explanation:
      'O usuário não está autorizado a entrar. Pode estar desativado, sem permissão para acessar o sistema ou a senha estar incorreta.',
    localizations: {},
    message: 'Não foi possível fazer login. Verifique suas informações e tente novamente.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'sign-in'>;
